import * as React from "react";
import { IOWidget, mk_widget, option, Options, Unit, Widget } from "../widget";

export type LabelOptions = Options & {
  htmlFor?:string
  label_position?:"before" | "after"
}

interface LabelProps<i,o> {
  text:string
  options?:LabelOptions
  input:i
  inner_widget:IOWidget<i,o>
  on_done:(output:o) => void
}

interface LabelState<_i,_o> { }

class Label<i,o> extends React.Component<LabelProps<i,o>, LabelState<i,o>> {
  constructor(props:LabelProps<i,o>, context:any) {
    super(props, context)

    this.state = { value:props.input }
  }

  render() {
    let l = <label className={option("className", this.props.options)} htmlFor={this.props.options ? this.props.options.htmlFor : undefined}>{this.props.text}</label>
    let w = this.props.inner_widget(this.props.input).run(output => this.props.on_done(output))
    return option("label_position", this.props.options) == "before" ?
        <React.Fragment key={option("key", this.props.options)}>{l}{w}</React.Fragment>
      : option("label_position", this.props.options) == "after" ?
        <React.Fragment key={option("key", this.props.options)}>{w}{l}</React.Fragment>
      : <React.Fragment key={option("key", this.props.options)}>{w}{l}</React.Fragment>
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const label_io = function<i,o>(text:string, options?:LabelOptions) : (_:IOWidget<i,o>) => IOWidget<i,o> {
  return inner_widget => (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<LabelProps<i,o>>(Label, { on_done, inner_widget, input, text, options })
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const label = function<o>(text:string, options?:LabelOptions) : (_:Widget<o>) => Widget<o> {
  return inner_widget => label_io<Unit,o>(text, options)(_ => inner_widget)({})
}
